export default __webpack_public_path__ + "static/media/bg-news.fd8df9b3.png";